// extracted by mini-css-extract-plugin
export default {"root":"GameItem_root__+iOKR","nameWrapper":"GameItem_nameWrapper__saK4A","icon":"GameItem_icon__2iJhh"};